import { memo } from 'react';
import { useSelector } from '@client/hooks/redux.hooks';
import { getUserOwnedTicketForCurrentShow } from '@client/selectors/entities/shows';
import type { Ticket } from '@sda/interfaces/ticket';

interface LocationProps {
  readonly location: string;
}

export const Location = memo<LocationProps>(({ location }) => {
  const userTicket = useSelector(getUserOwnedTicketForCurrentShow) as Ticket;

  if (userTicket?.compiledAddress) {
    return (
      <>
        {userTicket.compiledAddress}
      </>
    );
  }

  return (
    <>
      {location}
    </>
  );
});
